import { tss } from 'tss-react/mui';

export const useSimpleVoiceAssistantStyles = tss.create(({ theme }) => ({
  '@keyframes slideUp': {
    from: { opacity: 0, transform: 'translateY(10px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  slideUp: {
    animation: '$slideUp 0.3s ease-out forwards',
  },
  connectedContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
  },
  transcriptionContainer: {
    flex: 1,
    width: '100%',
    backgroundColor: theme.palette.surface.raised,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '380px',
    borderBottom: `1px solid ${theme.palette.status.neutral.background}`,
  },
  callIdHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    padding: '8px 16px',
    flexShrink: 0,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.status.neutral.background}`,
  },
  conversationView: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
  },
  controlBarContainer: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));
